import { lazy } from 'react';

import { Loadable } from '../../../../utils';

export const Customer = Loadable(lazy(() => import('../containers/CustomersContainer')));
